import { render, staticRenderFns } from "./mygoods_list.vue?vue&type=template&id=313ffede&scoped=true"
import script from "./mygoods_list.vue?vue&type=script&lang=js"
export * from "./mygoods_list.vue?vue&type=script&lang=js"
import style0 from "./mygoods_list.vue?vue&type=style&index=0&id=313ffede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ffede",
  null
  
)

export default component.exports